var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-sync"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }